export var OrganizationType;
(function (OrganizationType) {
    OrganizationType[OrganizationType["AfDivision"] = 0] = "AfDivision";
    OrganizationType[OrganizationType["ClaimsDivision"] = 1] = "ClaimsDivision";
    OrganizationType[OrganizationType["Underwriters"] = 2] = "Underwriters";
    OrganizationType[OrganizationType["Issuers"] = 3] = "Issuers";
    OrganizationType[OrganizationType["Brokers"] = 4] = "Brokers";
    OrganizationType[OrganizationType["LawEnforcement"] = 5] = "LawEnforcement";
    OrganizationType[OrganizationType["ExternalPartners"] = 6] = "ExternalPartners";
    OrganizationType[OrganizationType["GarageKeeper"] = 7] = "GarageKeeper";
    OrganizationType[OrganizationType["HighwayTrafficBoard"] = 8] = "HighwayTrafficBoard";
    OrganizationType[OrganizationType["GovernmentAgency"] = 9] = "GovernmentAgency";
    OrganizationType[OrganizationType["ParkingAndBylawEnforcement"] = 11] = "ParkingAndBylawEnforcement";
    OrganizationType[OrganizationType["ExternalIssuer"] = 12] = "ExternalIssuer";
})(OrganizationType || (OrganizationType = {}));
